const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

//传入时间，返回10位时间戳
function ts(date) {
  var date = new Date(date)
  ts = Math.round(date.getTime() / 1000).toString();
  return ts
}

// 传入分钟，获取+-的时间
function ta(minutes) {
  var t = new Date();
  t.setTime(t.setMinutes(t.getMinutes() + minutes));
  return t
}

function tats(minutes) {
  return ts(ta(minutes))
}

//format time y-m-d h:m:s
function ft(date) {
  var timestamp = Date.parse(new Date(date));
  timestamp = timestamp / 1000;
  var n = timestamp * 1000;
  var date = new Date(n);
  var Y = date.getFullYear();
  var M = (date.getMonth() + 1);
  var D = date.getDate();
  var h = date.getHours();
  var m = date.getMinutes();
  var s = date.getSeconds();
  return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
}

function timeDiff(ts2) {
  var date1 = new Date()
  var date2 = new Date(ts2 * 1000)
  var s1 = date1.getTime(), s2 = date2.getTime();
  var total = (s2 - s1) / 1000;
  var day = parseInt(total / (24 * 60 * 60));
  var afterDay = total - day * 24 * 60 * 60;
  var hour = parseInt(afterDay / (60 * 60));
  var afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60;
  var min = parseInt(afterHour / 60);
  var afterMin = parseInt(total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60);
  return {
    hour: hour,
    min: min,
    second: afterMin,
  }
}

function secondToDate(result) {
  var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  return result = h + ":" + m + ":" + s;
}

function md5(string) {
  var x = Array();
  var k, AA, BB, CC, DD, a, b, c, d;
  var S11 = 7,
    S12 = 12,
    S13 = 17,
    S14 = 22;
  var S21 = 5,
    S22 = 9,
    S23 = 14,
    S24 = 20;
  var S31 = 4,
    S32 = 11,
    S33 = 16,
    S34 = 23;
  var S41 = 6,
    S42 = 10,
    S43 = 15,
    S44 = 21;
  string = Utf8Encode(string);
  x = ConvertToWordArray(string);
  a = 0x67452301;
  b = 0xEFCDAB89;
  c = 0x98BADCFE;
  d = 0x10325476;
  for (k = 0; k < x.length; k += 16) {
    AA = a;
    BB = b;
    CC = c;
    DD = d;
    a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
    d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
    c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
    b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
    a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
    d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
    c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
    b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
    a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
    d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
    c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
    b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
    a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
    d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
    c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
    b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
    a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
    d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
    c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
    b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
    a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
    d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
    c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
    b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
    a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
    d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
    c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
    b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
    a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
    d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
    c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
    b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
    a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
    d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
    c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
    b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
    a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
    d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
    c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
    b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
    a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
    d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
    c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
    b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
    a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
    d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
    c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
    b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
    a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
    d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
    c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
    b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
    a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
    d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
    c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
    b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
    a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
    d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
    c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
    b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
    a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
    d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
    c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
    b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
    a = AddUnsigned(a, AA);
    b = AddUnsigned(b, BB);
    c = AddUnsigned(c, CC);
    d = AddUnsigned(d, DD);
  }
  var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);
  return temp.toUpperCase();
}

function RotateLeft(lValue, iShiftBits) {
  return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
}

function AddUnsigned(lX, lY) {
  var lX4, lY4, lX8, lY8, lResult;
  lX8 = (lX & 0x80000000);
  lY8 = (lY & 0x80000000);
  lX4 = (lX & 0x40000000);
  lY4 = (lY & 0x40000000);
  lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
  if (lX4 & lY4) {
    return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
  }
  if (lX4 | lY4) {
    if (lResult & 0x40000000) {
      return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
    } else {
      return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
    }
  } else {
    return (lResult ^ lX8 ^ lY8);
  }
}

function F(x, y, z) {
  return (x & y) | ((~x) & z);
}

function G(x, y, z) {
  return (x & z) | (y & (~z));
}

function H(x, y, z) {
  return (x ^ y ^ z);
}

function I(x, y, z) {
  return (y ^ (x | (~z)));
}

function FF(a, b, c, d, x, s, ac) {
  a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
  return AddUnsigned(RotateLeft(a, s), b);
}

function GG(a, b, c, d, x, s, ac) {
  a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
  return AddUnsigned(RotateLeft(a, s), b);
}

function HH(a, b, c, d, x, s, ac) {
  a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
  return AddUnsigned(RotateLeft(a, s), b);
}

function II(a, b, c, d, x, s, ac) {
  a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
  return AddUnsigned(RotateLeft(a, s), b);
}

function ConvertToWordArray(string) {
  var lWordCount;
  var lMessageLength = string.length;
  var lNumberOfWords_temp1 = lMessageLength + 8;
  var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
  var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
  var lWordArray = Array(lNumberOfWords - 1);
  var lBytePosition = 0;
  var lByteCount = 0;
  while (lByteCount < lMessageLength) {
    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
    lBytePosition = (lByteCount % 4) * 8;
    lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
    lByteCount++;
  }
  lWordCount = (lByteCount - (lByteCount % 4)) / 4;
  lBytePosition = (lByteCount % 4) * 8;
  lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
  lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
  lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
  return lWordArray;
}

function WordToHex(lValue) {
  var WordToHexValue = "",
    WordToHexValue_temp = "",
    lByte, lCount;
  for (lCount = 0; lCount <= 3; lCount++) {
    lByte = (lValue >>> (lCount * 8)) & 255;
    WordToHexValue_temp = "0" + lByte.toString(16);
    WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
  }
  return WordToHexValue;
}

function Utf8Encode(string) {
  var utftext = "";
  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);
    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if ((c > 127) && (c < 2048)) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }
  }
  return utftext;
}

function sum(m, n) {
  var num = Math.floor(Math.random() * (m - n) + n);
  return num
}

function fs(size) {
  if (!size)
    return "";
  var num = 1024.00; //byte
  if (size < num)
    return size + "B";
  if (size < Math.pow(num, 2))
    return (size / num).toFixed(2) + "K";
  if (size < Math.pow(num, 3))
    return (size / Math.pow(num, 2)).toFixed(0) + "MB";
  if (size < Math.pow(num, 4))
    return (size / Math.pow(num, 3)).toFixed(0) + "GB";
  return (size / Math.pow(num, 4)).toFixed(0) + "T";
}


function gd(d2) {
  var a1 = Date.parse(new Date());
  var a2 = Date.parse(new Date(d2 * 1000));
  var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24));
  return day+1
}

function gd2(d1,d2) {
  var a1 = Date.parse(new Date(d1 * 1000));
  var a2 = Date.parse(new Date(d2 * 1000));
  var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24));
  return day+1
}

function randoms(n) {
  if (n > 21) return null
  return parseInt((Math.random() + 1) * Math.pow(10, n - 1))
}

function fileType(type){
  var types = ['doc','xls','ppt','pdf','image','music','movie','rar','html','psd','cad','iso','wim','gho','esd','exe','apk','dmg','common']
  var doc = /\.(doc|docx|wps|pags)$/i;
  var xls = /\.(xls|xlsx|et|numbers)$/i;
  var ppt = /\.(ppt|pptx|dps|key)$/i;
  var pdf = /\.(pdf)$/i;
  var image = /\.(bmp|jpg|jpeg|png|gif|GIF|tif|JPG|PNG|svg|heic|heif|pcx|tga|exif|fpx|cdr|pcd|dxf|ufo|eps|ai|raw|WMF|webp|icon)$/i;
  var music = /\.(mp3|WMA|FLAC|AAC|CD|WAVE|AIFF|MIDI|WMA|RealAudio|VQF|OggVorbis|AMR|APE|AAC|flac|ape)$/i;
  var movie = /\.(swf|avi|flv|mpg|rm|mov|wav|asx|3gp|mkv|rmvb|mp4|flash|mid|wmv|asf|vob|dat|m4v|wma|MPEG|MPEG-4|mpe|dat)$/i;
  var rar = /\.(rar|rar4|7Z|tar|zip|jar|cab|apz|ar|bz|car|dar|cpgz|ha|hbc|hbc2|hbe|hpk|hyp)$/i;
  var html = /\.(html|xml)$/i;
  var psd = /\.(psd)$/i;
  var cad = /\.(dwg)$/i;
  var iso = /\.(iso)$/i;
  var wim = /\.(wim)$/i;
  var gho = /\.(gho)$/i;
  var esd = /\.(esd)$/i;
  var exe = /\.(exe)$/i;
  var apk = /\.(apk)$/i;
  var dmg = /\.(dmg)$/i;
  var lnk = /\.(lnk)$/i;
  if (doc.test(type)){
    return 'doc'
  }
  else if (xls.test(type)) {
    return 'xls'
  }
  else if (ppt.test(type)) {
    return 'ppt'
  }
  else if (pdf.test(type)) {
    return 'pdf'
  }
  else if (image.test(type)) {
    return 'image'
  }
  else if (music.test(type)) {
    return 'music'
  }
  else if (movie.test(type)) {
    return 'movie'
  }
  else if (rar.test(type)) {
    return 'rar'
  }
  else if(html.test(type)) {
    return 'html'
  }
  else if(psd.test(type)) {
    return 'psd'
  }
  else if(cad.test(type)) {
    return 'cad'
  }
  else if(iso.test(type)) {
    return 'iso'
  }
  else if(wim.test(type)) {
    return 'wim'
  }
  else if(gho.test(type)) {
    return 'gho'
  }
  else if(esd.test(type)) {
    return 'esd'
  }
  else if(exe.test(type)) {
    return 'exe'
  }
  else if(apk.test(type)) {
    return 'apk'
  }
  else if(dmg.test(type)) {
    return 'dmg'
  }else if (lnk.test(type)) {
    return 'lnk'
  }else{
    return 'common'
  }
}

function fileTypeImage(type){
  var image = /\.(bmp|jpg|jpeg|png|gif|GIF|tif|JPG|PNG|webp)$/i;
 if (image.test(type)) {
    return true
  }
}

function versionRequirements(ver1='0.0', ver2)
{
  if (ver1 === ver2) return true;
  var isVersion = false;
  var ver1Array = versionCompletion(ver1);
  var ver2Array = versionCompletion(ver2);
  for (var i = 0; i < 4; i++) {
    var v1 = toNumber(ver1Array[i]);
    var v2 = toNumber(ver2Array[i]);
    if(v1 > v2)
    {
      isVersion = true;
      break;
    }
  }

  if (!isVersion)
  {
    wx.showToast({
      title: '使用此功能需把PC客户端更新至最新版',
      icon: 'none',
      duration: 3000
    });
    return false;
  }
  else
  {
    return true;
  }
}

function toNumber(val)
{
  val = Number(val);
  if (isNaN(val)) val = 0;
  return val;
}

function versionCompletion(ver)
{
  if (isEmpty(ver) || ver.indexOf(".") === -1) return new Array("1", "0", "0","0");
  var verArray = ver.split('.');
  if (verArray.length >= 4) return verArray;
  var count = 4 - verArray.length;
  for (var i = 0; i < count;i++)
  {
    ver += ".0";
  }

  return ver.split('.');
}

function isEmpty(obj) {
  if (typeof obj == "undefined" || obj == null || obj == "") {
    return true;
  } else {
    return false;
  }
}

function random(maxi)
{
  var Num = "";
  for (var i = 0; i < maxi; i++) {
    Num += Math.floor(Math.random() * 10);
  }

  return Num;
}

function convertMemory(memory, types = 0) {

  let units = types === 1 ? "M" : " MB";
  let units2 = types === 1 ? "G" : " GB";

  let newMemory = memory;
  if (newMemory < 1024) {
    newMemory = newMemory + units;
  } else {
    newMemory = (newMemory / 1024).toFixed(1) + units2;
  }
  return newMemory;
}
function replaceCpuName(name)
{
  if (isEmpty(name)) return name;
  //g 代表全局替换  i 代表 忽略大小写
  name = name.replace(/\(r\)/gi, '');
  name = name.replace(/\(tm\)/gi, '');
  name = name.replace(/Intel/gi, '英特尔');
  return name;
}
function replaceVideocontrollerName(name) {
  if (isEmpty(name)) return name;
  //g 代表全局替换  i 代表 忽略大小写
  name = name.replace(/\(r\)/gi, '');
  name = name.replace(/\(tm\)/gi, '');
  name = name.replace(/Intel/gi, '英特尔');
  name = name.replace(/NVIDIA/gi, '英伟达');
  name = name.replace(/Matrox/gi, 'Matrox');
  //name = name.replace(/Microsoft/gi, '微软');
  name = name.replace(/ASUS/gi, '华硕');
  //name = name.replace(/Radeon/gi, '镭龙');
  name = name.replace(/ATI/gi, 'ATI');
  name = name.replace(/AMD/gi, 'AMD');
  return name;
}
function physicalmemoryDDR(val)
{
  var index = 1;
  val = parseInt(val);
  if (val >= 2133)
  {
    index = 4;
  }
  else if (val >= 1066)
  {
    index = 3;
  }
  else if (val >= 533)
  {
    index = 2;
  }

  return index;
}
function replacePhysicalmemoryName(name) {
  if (isEmpty(name)) return name;
  //g 代表全局替换  i 代表 忽略大小写
  // 遇到带有城市地区的，直接截掉
  name = name.replace(/Shenzhen/gi, '');
  // 品牌
  name = name.replace(/a-data technology/gi, '威刚');
  name = name.replace(/a-data/gi, '威刚');
  name = name.replace(/Apacer Technology/gi, '宇瞻');
  name = name.replace(/apacer/gi, '宇瞻');
  name = name.replace(/asgard/gi, '阿斯加特');
  name = name.replace(/ASint Technology/gi, '昱联');
  name = name.replace(/asint/gi, '昱联');
  name = name.replace(/avexir/gi, '宇帷');
  name = name.replace(/colorful/gi, '七彩虹');
  name = name.replace(/corsair/gi, '海盗船');
  name = name.replace(/Crucial Technology/gi, '英睿达');
  name = name.replace(/crucial/gi, '英睿达');
  name = name.replace(/galax/gi, '影驰');
  name = name.replace(/geil/gi, '金邦');
  name = name.replace(/gloway/gi, '光威');
  name = name.replace(/g-skill/gi, '芝奇');
  name = name.replace(/G Skill/gi, '芝奇');
  name = name.replace(/sk hynix/gi, '海力士');
  name = name.replace(/skhynix/gi, '海力士');
  name = name.replace(/Hynix Semiconductor/gi, '海力士');
  name = name.replace(/hynix/gi, '海力士');
  name = name.replace(/hyundai/gi, '现代');
  name = name.replace(/kingmax/gi, '胜创');
  name = name.replace(/kingston/gi, '金士顿');
  name = name.replace(/klevv/gi, '科赋');
  name = name.replace(/maxsun/gi, '铭瑄');
  name = name.replace(/Micron Technology/gi, '镁光');
  name = name.replace(/Micron_Technolog/gi, '镁光');
  name = name.replace(/micron/gi, '镁光');
  name = name.replace(/Nanya Technology/gi, '南亚');
  name = name.replace(/nanya/gi, '南亚');
  name = name.replace(/samsung/gi, '三星');
  name = name.replace(/team group inc./gi, '十铨');
  name = name.replace(/tigo/gi, '金泰克');
  name = name.replace(/transcend/gi, '创见');
  name = name.replace(/Ramaxel Technology/gi, '记忆科技');
  name = name.replace(/Ramaxel/gi, '记忆科技');
  return name;
}

function replaceHardDiskName(name) {
  if (isEmpty(name)) return name;
  name = name.replace('-', " ").trim();
  name = name.replace('_', " ").trim();
  if (name.toLowerCase().indexOf("nvme") === 0){
    name = name.replace(/NVMe/gi, '');
  }
  if (name.toLowerCase().indexOf("ts") === 0) {
    name = name.replace(/ts/gi, '创见 ');
  }
  else if (name.toLowerCase().indexOf("st") === 0) {
    name = name.replace(/st/gi, '希捷 ');
  }
  else if (name.toLowerCase().indexOf("hs") === 0) {
    name = name.replace(/hs/gi, '海康威视 ');
  }
  else if (name.toLowerCase().indexOf("toshiba") !== -1) {
    name = name.replace(/toshiba/gi, '');
    name = "东芝 " + name;
  }
  else if (name.toLowerCase().indexOf("sk hynix") !== -1){
    name = name.replace(/sk hynix/gi, '');
    name = "海力士 " + name;
  }
  else if (name.toLowerCase().indexOf("skhynix") !== -1){
    name = name.replace(/skhynix/gi, '');
    name = "海力士 " + name;
  }else if (name.toLowerCase().indexOf("kioxia") !== -1){
    name = name.replace(/kioxia/gi, '');
    name = "铠侠 " + name;
  }else if (name.toLowerCase().indexOf("zhitai") !== -1){
    name = name.replace(/zhitai/gi, '');
    name = "致钛 " + name;
  }else if(name.toLowerCase().indexOf("konka") !== -1){
    name = name.replace(/konka/gi, '');
    name = "康佳 " + name;
  }else if(name.toLowerCase().indexOf("heoriady") !== -1){
    name = name.replace(/heoriady/gi, '');
    name = "宏想 " + name;
  }
  else {
    var optional_data = new Array()
    optional_data['a'] = new Array()
    optional_data['a']['acer'] = "宏碁";
    optional_data['a']['adata'] = "威刚";
    optional_data['a']['aigo'] = "爱国者";
    optional_data['a']['amsta'] = "瑞势";
    optional_data['a']['apacer'] = "宇瞻";
    optional_data['a']['apple'] = "苹果";
    optional_data['a']['asgard'] = "阿斯加特";
    optional_data['a']['asint'] = "昱联";

    optional_data['b'] = new Array()
    optional_data['b']['biostar'] = "映泰";
    optional_data['c'] = new Array()
    optional_data['c']['colorful'] = "七彩虹";
    optional_data['d'] = new Array()
    optional_data['d']['derler'] = "德乐";
    optional_data['e'] = new Array()
    optional_data['e']['eaget'] = "忆捷";

    optional_data['f'] = new Array()
    optional_data['f']['fanxiang'] = "梵想";
    optional_data['f']['faspeed'] = "士必得";
    optional_data['f']['flashwar'] = "闪战";
    optional_data['f']['founder'] = "方正";
    optional_data['f']['fujitsu'] = "富士通";
    optional_data['g'] = new Array()
    optional_data['g']['gainward'] = "耕升";
    optional_data['g']['galax'] = "影驰";
    optional_data['g']['gigabyte'] = "技嘉";
    optional_data['g']['gloway'] = "光威";

    optional_data['h'] = new Array()
    optional_data['h']['hitachi'] = "日立";
    optional_data['h']['hp'] = "惠普";
    optional_data['h']['hs'] = "海康威视";
    optional_data['h']['heoriady'] = "宏想";

    optional_data['i'] = new Array()
    optional_data['i']['intel'] = "英特尔";
    optional_data['k'] = new Array()
    optional_data['k']['king share'] = "金胜";
    optional_data['k']['kingbank'] = "金百达";
    optional_data['k']['kingchuxing'] = "金储星";
    optional_data['k']['kingdian'] = "金典";
    optional_data['k']['kingston'] = "金士顿";

    optional_data['l'] = new Array()
    optional_data['l']['lenovo'] = "联想";
    optional_data['l']['lexar'] = "雷克沙";
    optional_data['l']['liteon'] = "建兴";
    optional_data['l']['liteonit'] = "建兴";

    optional_data['m'] = new Array()
    optional_data['m']['maxsun'] = "铭瑄";
    optional_data['m']['micron'] = "镁光";

    optional_data['n'] = new Array()
    optional_data['n']['netac'] = "朗科";

    optional_data['o'] = new Array()
    optional_data['o']['onda'] = "昂达";

    optional_data['p'] = new Array()
    optional_data['p']['phison'] = "群联";
    optional_data['p']['pioneer'] = "先锋";
    optional_data['p']['plextor'] = "浦科特";

    optional_data['r'] = new Array()
    optional_data['r']['reeinno'] = "创久";

    optional_data['s'] = new Array()
    optional_data['s']['samsung'] = "三星";
    optional_data['s']['sandisk'] = "闪迪";
    optional_data['s']['seagate'] = "希捷";
    optional_data['s']['shinedisk'] = "云储";
    optional_data['s']['sk hynix'] = "海力士";
    optional_data['s']['skhynix'] = "海力士";
    optional_data['s']['soyo'] = "梅捷";
    optional_data['s']['ssk'] = "飚王";
    optional_data['s']['st'] = "希捷";

    optional_data['t'] = new Array()
    optional_data['t']['team'] = "十铨";
    optional_data['t']['teclast'] = "台电";
    optional_data['t']['tigo'] = "金泰克";
    optional_data['t']['toshiba'] = "东芝";
    optional_data['t']['turxun'] = "台迅";

    optional_data['v'] = new Array()
    optional_data['v']['vaseky'] = "威士奇";
    optional_data['w'] = new Array()
    optional_data['w']['wdc'] = "西数";

    optional_data['y'] = new Array()
    optional_data['y']['yeston'] = "盈通";

    var data = name.trim();
    var array = data.split(' ');
    var company = array[0].toLowerCase();
    var initials = company.substr(0, 1);
    if (optional_data.hasOwnProperty(initials)) {
      if (optional_data[initials].hasOwnProperty(company)) {
        var remark = optional_data[initials][company];
        data = data.replace(new RegExp(company, "gi"), remark);
        return data;
      }
    }

  }

  return name;

}

function replaceBoardName(data)
{
  if (isEmpty(data)) return data;
  data = data.trim();
  var array = data.split(' ');
  var company = array[0].toLowerCase();
  var initials = company.substr(0, 1);

  var myBoard = new Array()
  myBoard['a'] = new Array()
  myBoard['a']['asustek'] = "华硕";
  myBoard['a']['asus'] = "华硕";
  myBoard['a']['apple'] = "苹果";
  myBoard['a']['alienware'] = "外星人";
  myBoard['a']['asrock'] = "华擎";
  myBoard['a']['acer'] = "宏碁";

  myBoard['b'] = new Array()
  myBoard['b']['biostar'] = "映泰";

  myBoard['c'] = new Array()
  myBoard['c']['colorful'] = "七彩虹";
  myBoard['c']['clevo'] = "蓝天";

  myBoard['d'] = new Array()
  myBoard['d']['dell'] = "戴尔";

  myBoard['e'] = new Array()
  myBoard['e']['es'] = "精英";

  myBoard['g'] = new Array()
  myBoard['g']['gigabyte'] = "技嘉";
  myBoard['g']['gigabyte'] = "技嘉";
  myBoard['g']['galax'] = "影驰";

  myBoard['h'] = new Array()
  myBoard['h']['hewlett-packard'] = "惠普";
  myBoard['h']['hp'] = "惠普";
  myBoard['h']['haier'] = "海尔";
  myBoard['h']['huawei'] = "华为";
  myBoard['h']['hasee'] = "神舟";
  myBoard['h']['huananzhi'] = "华南金牌";

  myBoard['i'] = new Array()
  myBoard['i']['inte'] = "英特尔";

  myBoard['l'] = new Array()
  myBoard['l']['lenovo'] = "联想";

  myBoard['m'] = new Array()
  myBoard['m']['maxsun'] = "铭瑄";
  myBoard['m']['micro'] = "微星";
  myBoard['m']['micro-star'] = "微星";
  myBoard['m']['mechrevo'] = "机械革命";
  myBoard['m']['machenike'] = "机械师";
  myBoard['m']['maibenben'] = "麦本本";

  myBoard['f'] = new Array()
  myBoard['f']['founder'] = "方正";
  myBoard['f']['fujitsu'] = "富士通";
  myBoard['f']['foxconn'] = "富士康";

  myBoard['o'] = new Array()
  myBoard['o']['onda'] = "昂达";

  myBoard['p'] = new Array()
  myBoard['p']['panasonic'] = "松下";
  myBoard['p']['pegatron'] = "和硕";
  myBoard['p']['pegatron'] = "和硕";

  myBoard['q'] = new Array()
  myBoard['q']['quanta'] = "广达";


  myBoard['u'] = new Array()
  myBoard['u']['unika'] = "昂达";

  myBoard['j'] = new Array()
  myBoard['j']['jetway'] = "捷波";
  myBoard['j']['j&w'] = "杰微";


  myBoard['s'] = new Array()
  myBoard['s']['soyo'] = "梅捷";
  myBoard['s']['samsung'] = "三星";
  myBoard['s']['shinelonr'] = "炫龙";
  myBoard['s']['supox'] = "磐正";
  myBoard['s']['seewo'] = "希沃";

  myBoard['y'] = new Array()
  myBoard['y']['yesto'] = "盈通";

  myBoard['t'] = new Array()
  myBoard['t']['tsinghua'] = "清华同方";
  myBoard['t']['toshiba'] = "东芝";
  myBoard['t']['thunderobot'] = "雷神";
  myBoard['t']['terrans'] = "未来人类";
  myBoard['t']['timi'] = "小米";

  if (myBoard.hasOwnProperty(initials)) {
    if (myBoard[initials].hasOwnProperty(company)) {
      var remark = myBoard[initials][company];
      if (data.toLowerCase().indexOf("ltd.") !== -1 || data.toLowerCase().indexOf("inc.") !== -1 || data.toLowerCase().indexOf("corporation.") !== -1 || data.toLowerCase().indexOf("ltd") !== -1) {
        var index = data.toLowerCase().indexOf("ltd.");
        index = index !== -1 ? index : data.toLowerCase().indexOf("inc.");
        index = index !== -1 ? index : data.toLowerCase().indexOf("corporation.");
        index = index !== -1 ? index : data.toLowerCase().indexOf("ltd");
        var strLength = data.length;
        return  remark + " " + data.substr(index + 4, strLength - index - 4);
      }
      else
      {
        return data.replace(new RegExp(company, "gi"), remark);

      }
    }
    else {
      return data; //不存在，提交
    }
  }
  else {
    return data; //不存在，提交
  }
}

/**
 * 通用复制文本
 * @param {String} text
 */
 const copyText = async (text) =>{
  try {
    await navigator.clipboard.writeText(text);
    alert('文本已复制到剪贴板!');
  } catch (err) {
    console.error('复制失败:', err);
  }
}


module.exports = {
  copyText: copyText,
  formatTime: formatTime,
  ts: ts,
  ta: ta,
  tats: tats,
  ft: ft,
  timeDiff: timeDiff,
  secondToDate: secondToDate,
  md5: md5,
  sum: sum,
  fs: fs,
  gd: gd,
  gd2: gd2,
  randoms: randoms,
  fileType:fileType,
  random: random,
  versionRequirements: versionRequirements,
  replaceCpuName: replaceCpuName,
  isEmpty: isEmpty,
  convertMemory: convertMemory,
  replaceBoardName: replaceBoardName,
  replaceVideocontrollerName: replaceVideocontrollerName,
  replaceHardDiskName: replaceHardDiskName,
  replacePhysicalmemoryName: replacePhysicalmemoryName,
  physicalmemoryDDR: physicalmemoryDDR,
  fileTypeImage,
}



// WEBPACK FOOTER //
// ./src/utils/util.js